import React, { useCallback, useEffect } from 'react'
import { triggerSentryError } from '../../../../shared/helpers'
import tts from '../../lib/TTS'
import { ErrorProps } from './types'

const ERROR_TEXT =
  'Error With Activation. Press OK or Enter to reset the app and try again.'

const ERROR_STRING = 'Error checking activation status'
const ERROR_TITLE = 'index.js'

function AppLaunchErrorScreen({ error }: ErrorProps) {
  const { type, data, name, message } = error
  const keyEventCallback = useCallback((event) => {
    if (event.keyCode === 13 || event.key === 'Enter') {
      window.location.href = '/'
    }
  }, [])

  useEffect(() => {
    tts.addTextToRead(ERROR_TEXT)
    triggerSentryError(
      ERROR_STRING,
      ERROR_TITLE,
      {
        errorName: name ?? 'An error occurred (default)',
        errorMessage: message ?? 'Undefined error message (default)',
      },
      true
    )
  }, [])

  useEffect(() => {
    document.addEventListener('keydown', keyEventCallback)

    return () => {
      document.removeEventListener('keydown', keyEventCallback)
    }
  }, [keyEventCallback])

  return (
    <div className="error-screen__container">
      <div className="error-screen__text-container">
        <h1 className="error-screen__title">Error Launching App</h1>
        <p className="error-screen__text">{type}</p>
        <p className="error-screen__text">{JSON.stringify(data?.message)}</p>
        <p className="error-screen__text">
          Press Ok or Enter to reset the app and try again.
        </p>
      </div>
    </div>
  )
}

export default AppLaunchErrorScreen
